module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"activeUnder":"До {date} г.","mb":"{num} МБ","SSD":"Сетевой диск SSD","SSD-Lite":"Сетевой диск SSD-Lite","HDD":"Сетевой диск HDD","gb":"{num} ГБ"}}')
  delete Component.options._Ctor
}
